import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import customStyles from "../styleMultiselect";


const AllMultiSelectCheckboxSector = ({datas, setSelectedsector}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const { t } = useTranslation();

  let options = datas.map((name, index) => (
    {value : name.value, label: t(name.label)}
  ))

  useEffect(() => {
    setSelectedOptions([{ label: "", value: "" }]);
  }, []);

  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === "*")) {
      return `${placeholderButtonLabel}: ${t('all')}`;
    } else if(value.some((o) => o.value === '')) {
      return `${placeholderButtonLabel}: ${value.length-1} ${t('selected')}`;
    }else{
      return `${placeholderButtonLabel}: ${value.length} ${t('selected')}`;
    }
  }

  function onChange(value, event) {
    if (event.action === "select-option" && event.option.value === "*") {
      this.setState(this.options);
      setSelectedsector(this.options)
    } else if (event.action === "deselect-option" && event.option.value === "*") {
      setSelectedsector([])
      this.setState([]);
    } else if (event.action === "deselect-option") {
      setSelectedsector(value.filter((o) => o.value !== "*"))
      this.setState(value.filter((o) => o.value !== "*"));
    } else if (value.length === this.options.length - 1) {
      setSelectedsector(this.options)
      this.setState(this.options);
    } else {
      setSelectedsector(value)
      this.setState(value);
    }
  }

  return (
    <ReactMultiSelectCheckboxes className="user-type"
      options={[{ label: `${t('all')}`, value: "*" }, ...options]}
      placeholderButtonLabel={t('sector')}
      getDropdownButtonLabel={getDropdownButtonLabel}
      value={selectedOptions}
      onChange={onChange}
      setState={setSelectedOptions}
      hideSearch={false}
      styles={customStyles}
    />
  );
};

export default AllMultiSelectCheckboxSector;